import Vue from 'vue'
import LaddaButton from 'codium-ladda-button'
import Alert from 'components/Alert'
import HelpBlock from 'components/HelpBlock'
import Multiselect from 'vue-multiselect'
import LoadingSpinner from 'components/LoadingSpinner'
import NoResults from 'components/NoResults'
import LazyLoading from 'codium-lazy-loading'
import DisabledOverlay from 'components/DisabledOverlay'
import ServerLink from 'components/ServerLink'

Vue.component('ladda-button', LaddaButton)
Vue.component('alert', Alert)
Vue.component('help-block', HelpBlock)
Vue.component('multiselect', Multiselect)
Vue.component('loading-spinner', LoadingSpinner)
Vue.component('no-results', NoResults)
Vue.component('lazy-loading', LazyLoading)
Vue.component('disabled-overlay', DisabledOverlay)
Vue.component('server-link', ServerLink)
